export const sanitizeTagText = text => {
    return (text ?? "").replace("#", "");
};
